export const NOT_AUTHORIZED_RESPONSE_EVENT = 'auth:not-authorized-response'
export const AUTH_LOGIN_SUCCESS_EVENT = 'auth:login-success'

const NOT_AUTHORIZED_MESSAGE = 'not authorized'

const normalizeMessage = (value) => (typeof value === 'string' ? value.trim().toLowerCase() : '')

export const isNotAuthorizedResponse = (response) => {
  // Only treat explicit auth failures as session-invalidating.
  // Some endpoints return "not authorized" as a business-rule message even when the
  // session is still valid, so status code is the safer signal for logout.
  if (![401, 403].includes(Number(response?.status))) return false

  const data = response?.data

  if (normalizeMessage(data) === NOT_AUTHORIZED_MESSAGE) return true

  const message = data?.msg || data?.message || data?.error
  return normalizeMessage(message) === NOT_AUTHORIZED_MESSAGE
}

export const notifyNotAuthorizedResponse = (response) => {
  if (typeof window === 'undefined' || !isNotAuthorizedResponse(response)) return

  window.dispatchEvent(new CustomEvent(NOT_AUTHORIZED_RESPONSE_EVENT, {
    detail: {
      status: response?.status,
      url: response?.config?.url,
    },
  }))
}

export const beginLoginTransition = () => {
  if (typeof window === 'undefined') return
  try {
    sessionStorage.setItem('auth_logging_in', '1')
  } catch (_error) {}
  window.showRootLoader?.('Logging In...')
}

export const clearLoginTransition = () => {
  if (typeof window === 'undefined') return
  try {
    sessionStorage.removeItem('auth_logging_in')
  } catch (_error) {}
}

export const notifyLoginSuccess = () => {
  if (typeof window === 'undefined') return
  window.dispatchEvent(new CustomEvent(AUTH_LOGIN_SUCCESS_EVENT))
}

/** Dashboard path after a successful email/phone login (onboarded users only). */
export const getPostLoginDashboardPath = (data) => {
  if (!data || typeof data.role === 'undefined' || data.role === null) return '/dashboard/app'
  return Number(data.role) === 0 ? '/dashboard/app' : '/stores/app'
}
